export function getDomainLanguage(req) {
    if (!req || !req.headers || !req.headers.host) {
        return ["1001promocodes.com", "us", "7"]; // Default domain and language
    }
    
    const currentUrl = req.headers.host.toLowerCase(); // Normalize case
    if (currentUrl.includes("1001cupomdedescontos.com.br")) {
        return ["1001cupomdedescontos.com.br", "br", "4"]; // 4 = matomo siteid 
    }
    if (currentUrl.includes("tipdeal.nl")) {
        return ["tipdeal.nl", "nl", "3"];
    }
    if (currentUrl.includes("tipdeal.be")) {
        return ["tipdeal.be", "be", "5"];
    }
    if (currentUrl.includes("codigosdescuentospromocionales.es")) {
        return ["codigosdescuentospromocionales.es", "es", "2"];
    }
    if (currentUrl.includes("1001promocodes.com")) {
        return ["1001promocodes.com", "us", "7"];
    }
    // Fallback
    return ["1001promocodes.com", "us", "7"];
}

export const formatString = (str) => {
    const currentYear = new Date().getFullYear();

    return str
        .replace(/\[year\]/g, currentYear)
        .replace(/\[flag by countrycode\]/g, '');
};
